import { observable } from 'mobx';

import { useEffect } from 'react';
import $$tracker from '@src/tracker';

class CommonHeaderStore {
  //是否开启剑网3免登
  @observable isMax = false;
  @observable show = false;

  @observable current = 0;
  @observable
  navList = [
    { id: 0, title: '首页' },
    { id: 1, title: '江湖快报' },
    { id: 2, title: '游戏特色' },
    { id: 3, title: '门派介绍' },
    { id: 4, title: '攻略资料' },
    { id: 5, title: '视听中心' },
    { id: 6, title: '关注我们' }
  ];

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  showMenu = show => {
    this.show = show;
  };

  setCurrent = (id, type) => {
    $$tracker.clickTopNav(this.navList[id].title);
    this.current = id;
    this.changeSwiperCallback(id, type);
  };

  goToMain = () => {
    this.current = 0;
    this.changeSwiperCallback(0);
  };

  changeSwiperCallback = () => {};

  use() {
    useEffect([]);
  }
}

export default CommonHeaderStore;
